import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiService } from '../api.service';
import { Customer } from '../../models/customer.model';
import { Observable } from 'rxjs';
import { CustomerPage } from '../../models/customerPage.model';
import { CompletionStatus } from '../../shared/enums/completion-status/completion-status.module';

@Injectable({
  providedIn: 'root'
})
export class CustomerService {

  constructor(private http: HttpClient, private apiService: ApiService) { }

  apiUrl = `${this.apiService.apiUrl}/customers`;

  getCustomer(customerId: string): Observable<Customer> {
    return this.http.get<Customer>(`${this.apiUrl}/${customerId}`);
  }

  getFirstAvailablePageUrl(customerId: string): Observable<string|null> {
    return this.http.get<string|null>(`${this.apiUrl}/${customerId}/availablePage`);
  }

  getCustomers(): Observable<Customer[]> {
    return this.http.get<Customer[]>(`${this.apiUrl}`);
  }

  updateCustomerPageStatus(customerId: string, customerPageId: string, status: CompletionStatus): Observable<void> {
    return this.http.patch<void>(`${this.apiUrl}/${customerId}/customerPages/${customerPageId}/status`, status);
  }

  updateCustomerPageInstructionStatus(customerId: string, customerPageId: string, status: boolean): Observable<void> {
    return this.http.patch<void>(`${this.apiUrl}/${customerId}/customerPages/${customerPageId}/instructions`, status);
  }
}
